var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconShares40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_11407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24678 29.7123C8.66024 29.7123 9.80607 28.5665 9.80607 27.153C9.80607 25.7396 8.66024 24.5938 7.24678 24.5938C5.83333 24.5938 4.6875 25.7396 4.6875 27.153C4.6875 28.5665 5.83333 29.7123 7.24678 29.7123Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5647 19.7953C16.9781 19.7953 18.1239 18.6495 18.1239 17.236C18.1239 15.8226 16.9781 14.6768 15.5647 14.6768C14.1512 14.6768 13.0054 15.8226 13.0054 17.236C13.0054 18.6495 14.1512 19.7953 15.5647 19.7953Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8818 25.8734C25.2952 25.8734 26.4411 24.7276 26.4411 23.3142C26.4411 21.9007 25.2952 20.7549 23.8818 20.7549C22.4683 20.7549 21.3225 21.9007 21.3225 23.3142C21.3225 24.7276 22.4683 25.8734 23.8818 25.8734Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.84 14.9965C34.2535 14.9965 35.3993 13.8507 35.3993 12.4372C35.3993 11.0238 34.2535 9.87793 32.84 9.87793C31.4266 9.87793 30.2808 11.0238 30.2808 12.4372C30.2808 13.8507 31.4266 14.9965 32.84 14.9965Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07056 25.5427L14.4698 19.4468",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7791 18.5762L22.1333 21.537",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6165 21.537L31.1898 14.5703",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_11407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconShares40);
export default __webpack_public_path__ + "static/media/pictogramBeaconShares40.4b82c6600a6363773b44675c2ce58612.svg";
export { ForwardRef as ReactComponent };